const configs = [];
var pluginConfig_default = configs;
export {
  pluginConfig_default as default
};
